const Message = (props) =>  (
    <span id="message">
        print("{props.text}") 
    </span>
);

export default Message;